import React, { useState } from "react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

import { MoreHorizontal } from "lucide-react";
import { Periode } from "@/types";
import Modal from "@/components/Modal";
import Form from "./Form";
import { Link } from "react-router-dom";
import FormSysProdi from "./FormSysProdi";
import FormSysBerkas from "./FormSysBerkas";
import FormSysBerkasPortofolio from "./FormSysBerkasPortofolio";

export default function Actions({ row }: { row: Periode }) {
  const [showEdit, setShowEdit] = useState(false);
  const [showEditListProdi, setShowEditListProdi] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showListProdi, setShowListProdi] = useState(false);
  const [showListBerkas, setShowListBerkas] = useState(false);
  const [showListBerkasPortofolio, setShowListBerkasPortofolio] =
    useState(false);
  const [selectedRow, setSelectedRow] = useState<Periode | null>(null);

  const isStudentExchange =
    row?.jalur_jenis?.nama_jalur_jenis_slug === "studentexchange";

  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() => {
                setShowEdit(true);
                setSelectedRow(row);
              }}
            >
              Edit
            </DropdownMenuItem>
            <Link
              to={`/admin/setting/periode/detail?id=${row?.id_sys_periode}`}
            >
              <DropdownMenuItem>Lihat Detail</DropdownMenuItem>
            </Link>
            <DropdownMenuSeparator />
            {row.sys_prodi &&
            row.sys_prodi?.length === 0 &&
            !isStudentExchange ? (
              <DropdownMenuItem
                onClick={() => {
                  setShowListProdi(true);
                  setSelectedRow(row);
                }}
              >
                Input List Prodi
              </DropdownMenuItem>
            ) : (
              <>
                {!isStudentExchange ? (
                  <>
                    <DropdownMenuItem
                      onClick={() => {
                        setShowEditListProdi(true);
                        setSelectedRow(row);
                      }}
                    >
                      Edit List Prodi
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      onClick={() => {
                        setShowListBerkasPortofolio(true);
                        setSelectedRow(row);
                      }}
                    >
                      Input List Berkas Portofolio
                    </DropdownMenuItem>
                  </>
                ) : (
                  ""
                )}
                <DropdownMenuItem
                  onClick={() => {
                    setShowListBerkas(true);
                    setSelectedRow(row);
                  }}
                >
                  Input List Berkas
                </DropdownMenuItem>
              </>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <Modal
        closeable={false}
        show={showEdit}
        onClose={() => setShowEdit(false)}
        className="lg:w-[80vw] w-[95vw]"
      >
        <Form
          closeModal={() => setShowEdit(false)}
          selectedRow={selectedRow}
          method="PATCH"
        />
      </Modal>

      <Modal show={showDelete} onClose={() => setShowDelete(false)}>
        <Form
          closeModal={() => setShowDelete(false)}
          selectedRow={selectedRow}
          method="DELETE"
        />
      </Modal>

      <Modal
        show={showListProdi}
        onClose={() => setShowListProdi(false)}
        className="w-[80vw]"
      >
        <FormSysProdi
          closeModal={() => setShowListProdi(false)}
          selectedRow={selectedRow}
          method="POST"
        />
      </Modal>

      <Modal
        show={showEditListProdi}
        onClose={() => setShowEditListProdi(false)}
        className="w-[80vw]"
      >
        <FormSysProdi
          closeModal={() => setShowEditListProdi(false)}
          selectedRow={selectedRow}
          method="PATCH"
        />
      </Modal>

      <Modal
        show={showListBerkas}
        onClose={() => setShowListBerkas(false)}
        className="lg:w-fit min-w-[30vw] max-w-[80vw]"
      >
        <FormSysBerkas
          method="POST"
          selectedRow={selectedRow}
          closeModal={() => setShowListBerkas(false)}
        />
      </Modal>

      <Modal
        show={showListBerkasPortofolio}
        onClose={() => setShowListBerkasPortofolio(false)}
        className="lg:w-fit min-w-[30vw] max-w-[80vw]"
      >
        <FormSysBerkasPortofolio
          method="POST"
          selectedRow={selectedRow}
          closeModal={() => setShowListBerkasPortofolio(false)}
        />
      </Modal>
    </React.Fragment>
  );
}
